import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    ml8: {
      marginLeft: theme.spacing(1)
    }
  });
});
